import * as actionTypes from './actionTypes'
import { errorHandler } from '../../lib/errorHandler'
import fetchHandler from '../../lib/fetchHandler'
import { znajdzWgNIP, znajdzWgKRS } from '../../lib/gusClient'
import CryptoJS from 'react-native-crypto-js'
import { tpayPaymentURL } from '../../lib/consts'
import { getKodBazowy } from '../../lib/kodSystemowy'

const login = (email, password) => {
  return (dispatch) => {
    return fetchHandler('zaloguj')({ Email: email, Haslo: password })
      .then(errorHandler)
      .then((res) => {
        if (res.Sukces) window.location.search = '?token=' + res.Dane
        else dispatch(loginFail(res.Komunikat))
      })
      .catch((err) => dispatch(loginFail(err.message)))
  }
}

const createAccount = (email, password) => {
  return (dispatch) => {
    return fetchHandler('zalozkonto')({ Email: email, Haslo: password })
      .then(errorHandler)
      .then((res) => {
        if (res.Sukces) window.location.search = '?token=' + res.Dane
        else dispatch(loginFail(res.Komunikat))
      })
      .catch((err) => dispatch(loginFail(err.message)))
  }
}

const getLicence = () => {
  return (dispatch) => {
    return fetchHandler('licencja')({})
      .then(errorHandler)
      .then((res) => {
        dispatch(
          getLicenceSuccess({
            email: res.Email,
            system: res.System,
            numer: res.NumerLicencji,
            status: res.StatusLicencji,
            nazwaFirmy: res.NazwaFirmy,
            dataWaznosciSesji: res.DataWaznosciSesji,
          }),
        )
        if (localStorage.idPliku) {
          if (
            (res.System !== 'ESPR' && res.StatusLicencji === '0') ||
            (res.System === 'ESPR' &&
              (res.StatusLicencji === '0' || res.StatusLicencji === '1'))
          )
            dispatch(loadFile(localStorage.idPliku))
        }
      })
      .catch((err) =>
        dispatch(getLicenceFail('Błąd sprawdzenia licencji - ' + err.message)),
      )
  }
}

const tpayPaymentMD5 = (kwota, crc) => {
  // znaki & w każdym z elementów wynikają z wymagań TPAY'a
  const str = '34473&' + kwota.toString() + '&' + crc + '&YJtURkShGM055sGQ'
  return CryptoJS.MD5(str).toString()
}

const createTpayUrl = (data, crcValue) => {
  const kwota = `&kwota=${data.wariantLicencji.cenaBrutto}`
  const crc = `&crc=${encodeURIComponent(crcValue)}`
  const opis = `&opis=${encodeURIComponent(
    `e-Sprawozdania (${data.wariantLicencji.wariantText})`,
  )}`
  const nazwisko = `&nazwisko=${encodeURIComponent(data.nazwaFirmy)}`
  const email = `&email=${encodeURIComponent(data.email)}`
  const adres = `&adres=${encodeURIComponent(data.adresZbiorczy)}`
  const kod = `&kod=${encodeURIComponent(data.kodPocztowy)}`
  const miasto = `&miasto=${encodeURIComponent(data.miejscowosc)}`
  const md5sum = `&md5sum=${tpayPaymentMD5(
    data.wariantLicencji.cenaBrutto,
    crcValue,
  )}`
  const wyn_url = `&wyn_url=${window.location.origin}/potwierdzplatnosc`
  const pow_url = `&pow_url=${window.location.href}`
  const url = `${tpayPaymentURL}${kwota}${crc}${opis}${nazwisko}${wyn_url}${pow_url}${email}${adres}${kod}${miasto}${md5sum}`
  return url
}

const registerPayment = (data) => {
  return (dispatch) => {
    return fetchHandler('zarejestrujplatnosc')({
      Nip: data.NIP,
      NazwaFirmy: data.nazwaFirmy,
      Ulica: data.ulica,
      NrDomu: data.nrDomu,
      NrLokalu: data.nrLokalu,
      Miejscowosc: data.miejscowosc,
      KodPocztowy: data.kodPocztowy,
      Poczta: data.poczta,
      Licencja: data.wariantLicencji.wariantInt,
      Netto: data.wariantLicencji.cenaNetto,
      Brutto: data.wariantLicencji.cenaBrutto,
      EmailDoFaktury: data.emailDoFaktury,
    })
      .then(errorHandler)
      .then((res) => {
        if (res.Sukces && res.Dane)
          window.location = createTpayUrl(data, res.Dane)
        else dispatch(loginFail(res.Komunikat))
      })
      .catch((err) => dispatch(loginFail(err.message)))
  }
}

const getAvailableStructures = (dataSporzadzenia, poczatekOkresu, koniecOkresu) => {
  return (dispatch) => {
    return fetchHandler('dajdostepnesprawozdania')({
      DataSporzadzenia: dataSporzadzenia,
      PoczatekOkresu: poczatekOkresu,
      KoniecOkresu: koniecOkresu,
    })
      .then(errorHandler)
      .then((res) => {
        dispatch(getAvailableStructuresSuccess(res.Lista))
      })
      .catch((err) => {
        dispatch(uploadFileFail(err.message))
      })
  }
}

const setStructure = (structure) => {
  if (!structure)
    return (dispatch) => {
      dispatch(setStructureFinish())
    }
  return (dispatch) => {
    return fetchHandler(
      'nowe',
      5000,
    )({
      KodSprawozdania: structure,
    })
      .then(errorHandler)
      .then((res) => {
        localStorage.setItem('idPliku', res.Id)
        dispatch(setStructureFinish())
        dispatch(fetchSections(null))
        dispatch(setValidityErrors(null))
        dispatch(uploadFileSuccsess(res, res.NazwaPliku))
        dispatch(setDates(res.PoczatekOkresu, res.KoniecOkresu))
        dispatch(downloadSections(res.Id, 1))
      })
      .catch((err) => {
        dispatch(uploadFileFail(err.message))
      })
  }
}

const loadGUS = (czyKRS, identyfikator, czyPobracPKD) => {
  return (dispatch) => {
    dispatch(setGUSLoading(true))
    if (czyKRS) return znajdzWgKRS(identyfikator)
    return znajdzWgNIP(identyfikator, czyPobracPKD)
  }
}

const uploadFile = (file) => {
  return (dispatch) => {
    dispatch(uploadFileStart(file.name))
    let blob = new Blob([file.name], { type: 'text/plain;charset=UTF-8' })
    return fetchHandler(
      'dodaj',
      null,
      false,
    )({ nazwapliku: blob, plik: file })
      .then(errorHandler)
      .then((res) => {
        dispatch(setDataSporzadzenia(res.DataSporzadzenia))
        dispatch(setOkresSprawozdania(res.PoczatekOkresu, res.KoniecOkresu))
        if (!res.Id) {
          dispatch(setCzyWyborDaty(true))
          dispatch(setPaczkaZip(file))
        } else {
          localStorage.setItem('idPliku', res.Id)
          dispatch(fetchSections(null))
          dispatch(setValidityErrors(null))
          dispatch(uploadFileSuccsess(res, res.NazwaPliku))
          dispatch(setDates(res.PoczatekOkresu, res.KoniecOkresu))
          dispatch(downloadSections(res.Id, 1))
        }
      })
      .catch((err) => {
        dispatch(uploadFileFail(err.message))
      })
  }
}

const uploadZipFile = (file, data, dateFrom, dateTo) => {
  return (dispatch) => {
    dispatch(uploadFileStart(file.name))
    return fetchHandler(
      'dodajpaczke',
      null,
      false,
    )({
      plik: file,
      DataSporzadzenia: data,
      PoczatekOkresu: dateFrom,
      KoniecOkresu: dateTo,
    })
      .then(errorHandler)
      .then((res) => {
        localStorage.setItem('idPliku', res.Id)
        dispatch(fetchSections(null))
        dispatch(setValidityErrors(null))
        dispatch(uploadFileSuccsess(res, res.NazwaPliku))
        dispatch(setDates(res.PoczatekOkresu, res.KoniecOkresu))
        dispatch(downloadSections(res.Id, 1))
        dispatch(setPaczkaZip(null))
      })
      .catch((err) => {
        dispatch(setPaczkaZip(null))
        dispatch(uploadFileFail(err.message))
      })
  }
}

const importCSV = (id, section, file) => {
  return (dispatch) => {
    dispatch(setCzyTrwaImport(true))
    dispatch(importCSVStart())
    return fetchHandler(
      'importcsv',
      null,
      false,
    )({
      IdPliku: id,
      Sekcja: new Blob([JSON.stringify(section)], { type: 'application/json' }),
      Plik: file,
    })
      .then(errorHandler)
      .then((res) => {
        dispatch(replaceSection(res, section.TypSekcji))
      })
      .then(() => dispatch(setCzyTrwaImport(false)))
      .catch((err) => dispatch(importCSVFail(err.message)))
  }
}

const uploadAttachment = (id, file, signal) => {
  return (dispatch) => {
    dispatch(uploadAttachmentStart(file.name))
    return fetchHandler(
      'dodajzalacznik',
      null,
      false,
      signal,
    )({
      IdPliku: id,
      Zalacznik: file,
    })
      .then(errorHandler)
      .catch((err) => dispatch(uploadAttachmentFail(err.message)))
  }
}

const downloadAttachment = (id, nazwa) => {
  return async (dispatch) => {
    dispatch(downloadAttachmentStart())
    await fetchHandler('pobierzzalacznik')({ Id: id, Nazwa: nazwa })
      .then((res) => errorHandler(res, true))
      .then((res) => {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(res, nazwa)
        } else {
          var a = document.createElement('a')
          var url = window.URL.createObjectURL(res)
          a.href = url
          a.download = nazwa
          a.dispatchEvent(new MouseEvent(`click`))
          window.URL.revokeObjectURL(url)
        }
      })
      .catch((err) => dispatch(downloadAttachmentFail(err.message)))
  }
}

const downloadSections = (id, page) => {
  return (dispatch) => {
    dispatch(downloadSectionsStart())
    return fetchHandler(
      'dajsekcje',
      5000,
    )({
      IdPliku: id,
      IdStrony: page,
    })
      .then(errorHandler)
      .then((res) => {
        if (page) dispatch(setCzyPodsumowanie(false))
        else dispatch(setCzyPodsumowanie(true))
        dispatch(clearError())
        return dispatch(fetchSections(res))
      })
      .then((res) => {
        if (Number(page) === 1) {
          dispatch(setName(res.sections[0].Dane.NazwaFirmy))
          dispatch(
            setCzyKRS(
              res.sections[0].Dane.CzyKRS ||
                res.sections[0].Dane.KRS !== undefined,
            ),
          )
        }
      })
      .catch((err) => dispatch(downloadSectionsFail(err.message)))
  }
}

const saveSections = (id, s, withStateClear = true) => {
  return (dispatch) => {
    dispatch(saveSectionsStart())
    return fetchHandler(
      'zapiszsekcje',
      5000,
    )({
      IdPliku: id,
      Sekcje: s.length && s[0].Dane ? s : [],
    })
      .then((res) => errorHandler(res, false, false))
      .then(withStateClear ? dispatch(fetchSections(null)) : null)
      .catch((err) => dispatch(saveSectionsFail(err.message)))
  }
}

const loadFile = (idPliku) => {
  return (dispatch) => {
    return fetchHandler('wczytaj')({ IdPliku: idPliku })
      .then(errorHandler)
      .then((res) => {
        if (res && res.KodSystemowy) {
          dispatch(uploadFileSuccsess(res, res.NazwaPliku))
          dispatch(setDates(res.PoczatekOkresu, res.KoniecOkresu))
          dispatch(downloadSections(res.Id, 1))
        }
      })
      .catch((err) => {
        dispatch(loadFileFail(err.message))
      })
  }
}

const tytulPola = (nazwaPola, sciezka) => {
  const pola = [
    { nazwa: 'NazwaFirmy', opis: 'Nazwa firmy' },
    { nazwa: 'NrDomu', opis: 'Nr domu' },
    { nazwa: 'NrLokalu', opis: 'Nr lokalu' },
    { nazwa: 'Miejscowosc', opis: 'Miejscowość' },
    { nazwa: 'KodPocztowy', opis: 'Kod pocztowy' },
    { nazwa: 'KodKraju', opis: 'Kod kraju' },
    { nazwa: 'ZKodKraju', opis: 'Kod kraju przedsiębiorcy zagranicznego' },
    { nazwa: 'ZMiejscowosc', opis: 'Miejscowość przedsiębiorcy zagranicznego' },
    { nazwa: 'PoczatekOkresu', opis: 'Początek okresu' },
    { nazwa: 'KoniecOkresu', opis: 'Koniec okresu' },
    { nazwa: 'DataOd', opis: 'Początek działalności' },
    { nazwa: 'OpisMetody', opis: 'Opis metody' },
    { nazwa: 'OmowienieZasad', opis: 'Przyjęte zasady rachunkowości' },
    { nazwa: 'MetodyWyceny', opis: 'Metody wyceny aktywów i pasywów' },
    {
      nazwa: 'UstalenieWynikuFinansowego',
      opis: 'Zasady ustalenia wyniku finansowego',
    },
    {
      nazwa: 'UstalenieSposobuSporzadzenia',
      opis: 'Zasady ustalenia sposobu sporządzenia sprawozdania finansowego',
    },
    {
      nazwa: 'UstalenieWynikuFinansowegoOrazSposobuSporzadzenia',
      opis: 'Zasady ustalenia wyniku finansowego oraz sposobu sporządzenia sprawozdania finansowego',
    },
    { nazwa: 'DataSporzadzenia', opis: 'Data sporządzenia' },
    { nazwa: 'KodPKD', opis: 'Kod PKD' },
    { nazwa: 'P_1D', opis: 'NIP/KRS' },
    { nazwa: 'P_1C', opis: 'NIP/KRS' },
    { nazwa: 'NazwaPozycji', opis: 'Nazwa pozycji' },
    { nazwa: 'PodatekDochodowy', opis: 'Różnica między CIT/PIT a RZiS' },
    {
      nazwa: 'InformacjaDodatkowaDotyczacaPodatkuDochodowego',
      opis: 'Informacja Dodatkowa Dotycząca Podatku Dochodowego',
    },
    { nazwa: 'LaczneSprawozdanie', opis: 'Dane organizacyjne' },
    { nazwa: 'Kontynuacja', opis: 'Dane organizacyjne' },
    {
      nazwa: 'Zagrozenie',
      opis: 'Dane organizacyjne',
    },
    { nazwa: 'SporzadzonoPoPolaczeniu', opis: 'Dane organizacyjne' },
    { nazwa: 'ZakresDzialalnosciDM', opis: 'Zakres działalności' },
    {
      nazwa: 'OpisKryteriowObjeciaSprFin',
      opis: 'Opis kryterium objęcia sprawozdaniem',
    },
    {
      nazwa: 'OpisKryteriowWylaczen',
      opis: 'Opis kryterium wyłączeń ze sprawozdania',
    },
    { nazwa: 'NazwyJednostek', opis: 'Nazwy jednostek' },
    {
      nazwa: 'PrzedmiotDzialalnosci',
      opis: 'Podstawowy przedmiot działalności',
    },
    {
      nazwa: 'UdzialJednDominujacejWKapitale',
      opis: 'Udział jednostki dominującej w kapitale',
    },
    {
      nazwa: 'WzajemnePowiazanieKapitalowe',
      opis: 'Wzajemne powiązania kapitałowe',
    },
    {
      nazwa: 'UzasadnienieWylaczenia',
      opis: 'Uzasadnienie wyłączenia',
    },
    {
      nazwa: 'UdzialJednDominujacej',
      opis: 'Udział jednostki dominującej',
    },
    {
      nazwa: 'ZasadyGrupowania',
      opis: 'Zasady grupowania operacji gospodarczych',
    },
    {
      nazwa: 'MetodyAmortyzacji',
      opis: 'Metody dokonywania amortyzacji',
    },
    {
      nazwa: 'NazwaJednostki',
      opis: 'Nazwa jednostki',
    },
    {
      nazwa: 'NrKRS',
      opis: 'Numer KRS',
    },
    {
      nazwa: 'NrNIP',
      opis: 'NIP',
    },
    {
      nazwa: 'Wojewodztwo',
      opis: 'Województwo',
    },
  ]
  if (nazwaPola === 'IdentyfikatorPodmiotu') {
    const splitted = sciezka.split('/')
    if (splitted.length !== 0) {
      const pole = pola.find((v) => v.nazwa === splitted[splitted.length - 1])
      if (pole) return pole.opis
      return splitted[splitted.length - 1]
    }
  }
  const pole = pola.find((v) => v.nazwa === nazwaPola)
  if (pole) return pole.opis
  return nazwaPola
}

const getTypSekcji = (sciezka) => {
  if (sciezka) {
    if (sciezka.includes('RachPrzeplywow'))
      return 'RachunekPrzeplywowPienieznych'
    if (sciezka.includes('ZestZmianWKapitale'))
      return 'ZestawienieZmianWKapitale'
  }
  return 'Nieznana'
}

const prepareErrors = (errors) => {
  let errorList = errors.filter((error) => error.NazwaPola)
  if (errorList.length === 0) errorList = errors
  errorList = errorList.map((error) => {
    return {
      ...error,
      TytulPola: error.NazwaPola
        ? tytulPola(error.NazwaPola, error.Sciezka, error.Wartosc)
        : 'Plik XML',
      OpisBledu: getDescribe(error),
      TypSekcji:
        error.TypSekcji === 'Nieznana'
          ? getTypSekcji(error.Sciezka)
          : error.TypSekcji,
    }
  })
  let result = []
  errorList.forEach((error) => {
    let sameError = false
    if (error.OpisBledu.includes('niezweryfikowane dane sekcji obowiązkowej')) {
      sameError = result.find(
        (val) =>
          val.TytulPola === error.TytulPola &&
          val.OpisBledu === error.OpisBledu,
      )
    }
    if (!sameError) result.push(error)
  })
  return result
}

const getDescribe = (error) => {
  if (error.NazwaPola) {
    if (error.Komunikat === 'Niewypełniona sekcja')
      return 'niezweryfikowane dane sekcji obowiązkowej - sprawdź/uzupełnij dane'
    if (error.Wartosc) return `niepoprawna wartość pola (${error.Wartosc})`
    return 'niewypełnione pole'
  }
  return 'struktura pliku niezgodna ze schematem'
}

const checkValidity = (id, sections, setErrors = true) => {
  return async (dispatch) => {
    dispatch(checkValidityStart())
    dispatch(setCzyTrwaSprawdzanie(true))
    sections &&
      sections.length > 0 &&
      sections[0].TypSekcji !== 'Walidacja' &&
      (await fetchHandler(
        'zapiszsekcje',
        5000,
      )({
        IdPliku: id,
        Sekcje: sections,
      })
        .then((res) => errorHandler(res, false, false))
        .catch((err) => dispatch(saveSectionsFail(err.message))))
    return await fetchHandler('sprawdz')({
      IdPliku: id,
    })
      .then(errorHandler)
      .then((res) => {
        const result = setErrors
          ? dispatch(setValidityErrors(prepareErrors(res)))
          : prepareErrors(res)
        dispatch(setCzyTrwaSprawdzanie(false))
        return result
      })
      .catch((err) => dispatch(checkValidityFail(err.message)))
  }
}

const downloadFile = (id, name, sections) => {
  return async (dispatch) => {
    dispatch(downloadFileStart())
    sections &&
      sections.length > 0 &&
      sections[0].TypSekcji !== 'Walidacja' &&
      (await fetchHandler(
        'zapiszsekcje',
        5000,
      )({
        IdPliku: id,
        Sekcje: sections,
      })
        .then((res) => errorHandler(res, false, false))
        .catch((err) => dispatch(saveSectionsFail(err.message))))
    await fetchHandler('pobierz')({ IdPliku: id })
      .then((res) => errorHandler(res, true))
      .then((res) => {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(res, name)
        } else {
          var a = document.createElement('a')
          var url = window.URL.createObjectURL(res)
          a.href = url
          a.download = name
          a.dispatchEvent(new MouseEvent(`click`))
          window.URL.revokeObjectURL(url)
        }
      })
      .catch((err) => dispatch(downloadFileFail(err.message)))
  }
}

const getReport = (id, sections, setErrors = true) => {
  return async (dispatch) => {
    sections &&
      sections.length > 0 &&
      sections[0].TypSekcji !== 'Walidacja' &&
      (await fetchHandler(
        'zapiszsekcje',
        5000,
      )({
        IdPliku: id,
        Sekcje: sections,
      })
        .then((res) => {
          errorHandler(res, false, false)
        })
        .catch((err) => dispatch(saveSectionsFail(err.message))))
    return dispatch(downloadSections(id))
  }
}

const getLicenceFail = (err) => ({ type: actionTypes.GET_LICENCE_FAIL, err })

const loginFail = (err) => ({ type: actionTypes.LOGIN_FAIL, err })

const setGUSLoading = (isGUSLoading) => ({
  type: actionTypes.SET_GUS_LOADING,
  isGUSLoading,
})

const setCzyWyborDaty = (wyborDaty) => ({
  type: actionTypes.SET_CZY_WYBOR_DATY,
  wyborDaty,
  fileName: '',
})

const setDataSporzadzenia = (dataSporzadzenia) => ({
  type: actionTypes.SET_DATA_SPORZADZENIA,
  dataSporzadzenia,
})

const setOkresSprawozdania = (poczatekOkresu, koniecOkresu) => ({
  type: actionTypes.SET_OKRES_SPRAWOZDANIA,
  poczatekOkresu,
  koniecOkresu,
})

const setPaczkaZip = (paczkaZip) => ({
  type: actionTypes.SET_PACZKA_ZIP,
  paczkaZip,
})

const setCzyTrwaSprawdzanie = (czyTrwaSprawdzanie) => ({
  type: actionTypes.SET_CZY_TRWA_SPRAWDZANIE,
  czyTrwaSprawdzanie,
})

const setCzyTrwaImport = (czyTrwaImport) => ({
  type: actionTypes.SET_CZY_TRWA_IMPORT,
  czyTrwaImport,
})

const uploadFileStart = () => ({ type: actionTypes.UPLOAD_FILE_START })

const uploadFileSuccsess = (header, fileName) => ({
  type: actionTypes.UPLOAD_FILE_SUCCESS,
  header,
  fileName,
})

const uploadFileFail = (err) => ({
  type: actionTypes.UPLOAD_FILE_FAIL,
  err,
})

const uploadAttachmentStart = () => ({
  type: actionTypes.UPLOAD_ATTACHMENT_START,
})

const uploadAttachmentFail = (err) => ({
  type: actionTypes.UPLOAD_ATTACHMENT_FAIL,
  err,
})

const downloadAttachmentStart = () => ({
  type: actionTypes.DOWNLOAD_ATTACHMENT_START,
})

const downloadAttachmentFail = (err) => ({
  type: actionTypes.DOWNLOAD_ATTACHMENT_FAIL,
  err,
})

const downloadSectionsStart = () => ({
  type: actionTypes.DOWNLOAD_SECTIONS_START,
})

const downloadSectionsFail = (err) => ({
  type: actionTypes.DOWNLOAD_SECTIONS_FAIL,
  err,
})

const saveSectionsStart = () => ({ type: actionTypes.SAVE_SECTIONS_START })

const saveSectionsFail = (err) => ({
  type: actionTypes.SAVE_SECTIONS_FAIL,
  err,
})

const checkValidityStart = () => ({
  type: actionTypes.CHECK_VALIDITY_START,
})

const checkValidityFail = (err) => ({
  type: actionTypes.CHECK_VALIDITY_FAIL,
  err,
})

const downloadFileStart = () => ({
  type: actionTypes.DOWNLOAD_FILE_START,
})

const downloadFileFail = (err) => ({
  type: actionTypes.DOWNLOAD_FILE_FAIL,
  err,
})

const loadFileFail = (err) => ({
  type: actionTypes.LOAD_FILE_FAIL,
  err,
})

const importCSVStart = () => ({
  type: actionTypes.IMPORT_CSV_START,
})

const importCSVFail = (err) => ({
  type: actionTypes.IMPORT_CSV_FAIL,
  err,
})

const setDates = (dateFrom, dateTo) => ({
  type: actionTypes.SET_DATES,
  dateFrom,
  dateTo,
})

const setValidityErrors = (validityErrors) => ({
  type: actionTypes.SET_VALIDITY_ERRORS,
  validityErrors,
})

const setActualValidityError = (actualValidityError) => ({
  type: actionTypes.SET_ACTUAL_VALIDITY_ERROR,
  actualValidityError,
})

const fetchSections = (sections) => ({
  type: actionTypes.FETCH_SECTIONS,
  sections,
})

const replaceSection = (section, sectionType) => ({
  type: actionTypes.REPLACE_SECTION,
  section,
  sectionType,
})

const setCzyKRS = (czyKRS) => ({
  type: actionTypes.SET_CZY_KRS,
  czyKRS,
})

const setCzyWylaczoneFormulyZZwK = (value) => ({
  type: actionTypes.SET_CZY_WYLACZONE_FORMULY_ZZWK,
  value,
})

const setCzyPodsumowanie = (czyPodsumowanie) => ({
  type: actionTypes.SET_CZY_PODSUMOWANIE,
  czyPodsumowanie,
})

const setSectionData = (name, value, index) => ({
  type: actionTypes.SET_SECTION_DATA,
  name,
  value,
  index,
})

const setSectionDataArray = (value, elIndex, sIndex, name) => ({
  type: actionTypes.SET_SECTION_DATA_ARRAY,
  value,
  elIndex,
  sIndex,
  name,
})

const setSectionDataCustomArray = (value, elIndex, arrayName, name) => ({
  type: actionTypes.SET_SECTION_DATA_CUSTOM_ARRAY,
  value,
  elIndex,
  arrayName,
  name,
})

const setPozycjeUzytkownikaSkonsolid = (iInfo, iCIT, v) => ({
  type: actionTypes.SET_POZYCJE_UZ_SKONS,
  iInfo,
  iCIT,
  v,
})

const setPozycjeUzytkownikaSkonsolidV12 = (iInfo, iCIT, v) => ({
  type: actionTypes.SET_POZYCJE_UZ_SKONS_V12,
  iInfo,
  iCIT,
  v,
})

const setName = (name) => ({
  type: actionTypes.SET_NAME,
  name,
})

const clearError = () => ({
  type: actionTypes.CLEAR_ERROR,
})

const addDetailInfo = (structure, sIndex) => {
  return {
    type: actionTypes.ADD_DETAIL,
    structure,
    sIndex,
  }
}

const deleteDetail = (index, sIndex) => {
  return {
    type: actionTypes.DELETE_DETAIL,
    index,
    sIndex,
  }
}

const getLicenceSuccess = (licencja) => {
  return {
    type: actionTypes.GET_LICENCE_SUCCESS,
    licencja,
  }
}

const setZakupLicencji = (zakupLicencji) => {
  return {
    type: actionTypes.SET_ZAKUP_LICENCJI,
    zakupLicencji,
  }
}

const getSortedStructures = (structures) => {
  const arr = structures.map((element) => {
    const kodBazowy = getKodBazowy(element.KodSystemowy)
    switch (kodBazowy) {
      case 'SFJINZ':
        return { kod: element, priorytet: 0 }
      case 'SFJINT':
        return { kod: element, priorytet: 1 }
      case 'SFSINZ':
        return { kod: element, priorytet: 2 }
      case 'SFSINT':
        return { kod: element, priorytet: 3 }
      case 'SFJMAZ':
        return { kod: element, priorytet: 4 }
      case 'SFJMAT':
        return { kod: element, priorytet: 5 }
      case 'SFJMIZ':
        return { kod: element, priorytet: 6 }
      case 'SFJMIT':
        return { kod: element, priorytet: 7 }
      case 'SFJOPZ':
        return { kod: element, priorytet: 8 }
      case 'SFJOPT':
        return { kod: element, priorytet: 9 }
      case 'SFDMAZ':
        return { kod: element, priorytet: 10 }
      case 'SFDMAT':
        return { kod: element, priorytet: 11 }
      default:
        return { kod: element }
    }
  })
  return arr.sort((a, b) => {
    return a.priorytet - b.priorytet
  })
}

const getAvailableStructuresSuccess = (availableStructures) => {
  return {
    type: actionTypes.GET_STRUCTURES,
    availableStructures: getSortedStructures(availableStructures),
    fileName: '',
    wyborStruktury: true,
  }
}

const setStructureFinish = () => {
  return {
    type: actionTypes.SET_STRUCTURE,
    wyborStruktury: false,
  }
}

const clearTable = (arrayName) => {
  return {
    type: actionTypes.CLEAR_TABLE,
    arrayName,
  }
}

export {
  uploadFile,
  uploadAttachment,
  downloadAttachment,
  clearError,
  setSectionData,
  setSectionDataArray,
  setSectionDataCustomArray,
  setDates,
  checkValidity,
  setCzyKRS,
  downloadSections,
  saveSections,
  setValidityErrors,
  setActualValidityError,
  fetchSections,
  replaceSection,
  clearTable,
  addDetailInfo,
  deleteDetail,
  downloadFile,
  importCSV,
  setName,
  getLicence,
  login,
  createAccount,
  setZakupLicencji,
  setPozycjeUzytkownikaSkonsolid,
  setPozycjeUzytkownikaSkonsolidV12,
  getAvailableStructures,
  setStructure,
  setGUSLoading,
  loadGUS,
  registerPayment,
  setCzyPodsumowanie,
  getReport,
  setCzyTrwaSprawdzanie,
  setCzyTrwaImport,
  loadFile,
  setCzyWylaczoneFormulyZZwK,
  setCzyWyborDaty,
  setDataSporzadzenia,
  setOkresSprawozdania,
  setPaczkaZip,
  uploadZipFile,
}
